// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollRef_root__Uj1HJ","root--offset":"ScrollRef_root--offset__gqla7","ref":"ScrollRef_ref__T6kkl","rotation":"ScrollRef_rotation__RP5EJ"};